import $ from "jquery";
import { FIELD_PRODUCT_ORDER, EMPTY_COUNT, EMPTY_STRING } from "../../../../utils/constants"
import { FIELD_EMPTY } from "../../../../utils/messages";
import { isNullOrUndefined } from "util";

function setTotalTableStyle(totalName, startIndex) {

    function adjustTable() {

        let element = null
        let totalWidth = 0;
        let totalId = "#" + totalName
        let tableHeaders = $(".table-header th.fixed-header")

        tableHeaders.each(function (index) {
            if (startIndex <= index) {
                element = $(this)
                let colWidth = element.outerWidth() - 12

                if (index === startIndex) {
                    colWidth = colWidth / 2;
                }

                let headId = totalId + "-" + index;
                $(headId).css("maxWidth", colWidth)
                $(headId).css("minWidth", colWidth)
                $(headId).css("width", colWidth)
                $(headId).css("text-align", "right")
                $(headId).css("border", ".25px solid #ccc")
                totalWidth += colWidth

                if (index === tableHeaders.length - 1) {
                    $(totalId).css("float", "right")
                    $(totalId).css("width", totalWidth)
                }
            }
        });
    }

    $(window).resize(function () {
        adjustTable();
    });

    $(document).ready(function () {
        adjustTable();
    });

    adjustTable()

}

function validate(orderList) {

    let prompt = []

    orderList.map(item => {
        let qty = item[FIELD_PRODUCT_ORDER]
        let productCd = `商品コード[${item.productCode}] : `

        if (EMPTY_STRING === qty || isNullOrUndefined(qty) ){
            prompt.push(productCd+`数量${FIELD_EMPTY}`);
        }else if (EMPTY_COUNT > qty) {
            prompt.push(productCd + `数量[${qty}]は 0 以上を入力してください。`);
        }

        return item
    })

    return prompt
}

function checkOrderPattern(orderList) {
    let isInvalidOrderPattern = false

    orderList.map(item => {
        let qty = item[FIELD_PRODUCT_ORDER]
        let min = item.minOrder
        let max = item.maxOrder
        let multi = item.multiple

        if (EMPTY_COUNT < qty) {
            let diff = qty - min;
            if (EMPTY_COUNT < min && qty < min) {
                isInvalidOrderPattern = true;
            } else if (EMPTY_COUNT < max && EMPTY_COUNT < qty - max) {
                isInvalidOrderPattern = true;
            } else if (qty !== max){ 
                if (EMPTY_COUNT < diff && EMPTY_COUNT < diff % multi) {
                    isInvalidOrderPattern = true;
                }
            }
        } 

        return item
    })

    return isInvalidOrderPattern
}


export {
    setTotalTableStyle,
    validate,
    checkOrderPattern
};